module.exports = __webpack_public_path__ + "static/media/0520-a-r.d13d01ff.png";